const SQLBuilderItem = {
  actQuery: [{
    sid: '{005A5001-B9AD-41CB-8409-8F7675D19143}',
    tableName: 'BS_POS_GP_MA',
    tableCaption: '每日金价',
    kind: 'select'
  }, {
    sid: "{539BF364-32C3-4DE5-A34C-EFC354BD2A55}",
    tableName: 'BS_POS_GP_MA',
    tableCaption: '历史金价',
    kind: 'select'
  }]
}

/**
 * , {
    sid: "{539BF364-32C3-4DE5-A34C-EFC354BD2A55}",
    tableName: 'BS_POS_GP_MA',
    tableCaption: '历史金价',
    kind: 'select'
  }
 */
export default SQLBuilderItem



// WEBPACK FOOTER //
// ./src/wbap-unit-app/wbap-dashboard-dailyPrice/action.js